import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { WhatYouGet } from './components/WhatYouGet';
import { WhatYouImprove } from './components/WhatYouImprove';
import { Bonuses } from './components/Bonuses';
import { UrgencyPricing } from './components/UrgencyPricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { VerifiedPurchasePopup } from './components/VerifiedPurchasePopup';
export function App() {
  return <div className="min-h-screen bg-navy-900 text-white font-sans selection:bg-vbred selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <WhatYouGet data-id="element-3" />
      <WhatYouImprove data-id="element-4" />
      <Bonuses data-id="element-5" />
      <UrgencyPricing data-id="element-6" />
      <Testimonials data-id="element-7" />
      <FAQ data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <Footer data-id="element-10" />
      <VerifiedPurchasePopup data-id="element-11" />
    </div>;
}